export default __webpack_public_path__ + "static/media/RobotoMono-Italic-VariableFont_wght.7a7eaec2.woff";